import { useRef, useState } from "react";
import Input from "@app/components/Input";
import { UserConnexionResponse } from "@api/src/types/responses";
import { useNavigate } from "react-router";
import useUser from "@app/zustand/user";

export default function WelcomeConnexion() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(import.meta.env.VITE_EMAIL);
  const setUser = useUser((state) => state.setUser);
  const onboarding = useRef<{
    status_pro: string;
    specialite: string;
    etablissement: string;
    service: string;
    hopital: string;
  }>(
    window.localStorage.getItem("onboarding")
      ? JSON.parse(window.localStorage.getItem("onboarding")!)
      : {
          status_pro: "",
          specialite: "",
          etablissement: "",
          service: "",
          hopital: "",
        }
  ).current;

  const needVerif = !onboarding.etablissement;

  return (
    <>
      <span
        className="text-2xl text-sky-800"
        // onClick={() => {
        //   setDebugStandalone(true);
        // }}
      >
        Connectez-vous.
      </span>
      <span className="mb-6 text-2xl text-sky-800 opacity-75">Ou créez un nouveau compte.</span>
      <form
        action="/welcome/login-redirect"
        method="POST"
        className="flex h-full w-full max-w-md flex-shrink flex-grow flex-col py-4"
        autoComplete="off"
        encType="application/x-www-form-urlencoded"
        onSubmit={(e) => {
          const username = (e.target as HTMLFormElement).username.value;
          e.preventDefault();
          setLoading(true);
          fetch(`${import.meta.env.VITE_API_URL}/user/login-redirect`, {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email,
              username,
              etablissement: onboarding.etablissement,
              service: onboarding.service,
              hopital: onboarding.hopital,
              specialite: onboarding.specialite,
              status_pro: onboarding.status_pro,
            }),
          })
            .then((response) => response.json() as Promise<UserConnexionResponse>)
            .then((response) => {
              if (response.message === "Redirect to OTP") {
                navigate(`/welcome/login-redirect?email=${encodeURIComponent(response.data.user?.email || "")}`);
              } else if (response.message === "Redirect to Login Profile") {
                setUser(response.data.user);
                navigate("/welcome/login-profile");
              } else if (response.error) {
                alert(response.error);
              } else if (response.ok) {
                navigate("/");
              }
            })
            .finally(() => {
              setLoading(false);
            });
        }}
      >
        <Input
          label="Votre email"
          name="email"
          type="email"
          autoComplete="email"
          inputMode="email"
          placeholder="doc@medspot.fr"
          required
          customValidity="Veuillez entrer un email valide"
          value={email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
        />
        <input type="text" name="username" placeholder="Veuillez entrer un nom d'utilisateur" className="hidden" />
        <button
          className="mr-auto mt-5 inline-block rounded-lg border-none bg-sky-800 px-10 py-2 text-white disabled:cursor-not-allowed disabled:opacity-50"
          type="submit"
          disabled={loading}
        >
          {loading ? "Connexion..." : "Se connecter"}
        </button>
        {needVerif && (
          <span className="mr-auto mt-2 text-center text-xs text-sky-800 opacity-75">
            Un email vous sera envoyé
            <br /> avec un code de vérification
          </span>
        )}
        <footer className="mt-4 text-xs text-sky-800 opacity-45 md:mt-auto ">
          <p>Copyright Medspot {new Date().getFullYear()} - version 2.3.0</p>
        </footer>
      </form>
    </>
  );
}
